import _ from 'lodash';
import api from '../api';

const state = {
    data: {},
    meta: {}
};

const actions = {
    show: async ({ commit }, data) => {
        let apiUrl = 'onesignal/tags?user_id=' + data.user_id;

        return await api
            .patch(`/api/v1/${apiUrl}`)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    update: async ({}, data) => {
        let apiUrl = 'onesignal/user/tags?user_id=' + data.user_id + '&tags=' + JSON.stringify(data.tags);

        return await api
            .patch(`/api/v1/${apiUrl}`)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, data) {
        state.data = data.data;
        state.meta = data.meta;
    }
};

const getters = {
    get: (state) => {
        return state.data;
    },
    getMeta: (state) => {
        return state.meta;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
